import { Button, Grid, Typography } from '@mui/material'
import PlusIcon from '@mui/icons-material/Add'
import { yupResolver } from '@hookform/resolvers/yup'
import { useEffect } from 'react'
import { useFieldArray, useForm } from 'react-hook-form'

import { FormContext } from '../Contexts'
import { ReferencesValidationSchema } from './ValidationSchemas'

import { FormHandleSubmit, GetSchemaValidation } from '../types'
import { PersonalReferenceBlock, ProfessionalReferenceBlock } from './Components'

export const ReferencesStep = ({
  id,
  data,
  setActiveForm,
}: {
  id: string
  data?: GetSchemaValidation<typeof ReferencesValidationSchema>
  setActiveForm: (handleSubmit: () => FormHandleSubmit<GetSchemaValidation<typeof ReferencesValidationSchema>>) => void
}) => {
  const { control, handleSubmit, register, setValue, watch, formState, getValues } = useForm({
    resolver: yupResolver(ReferencesValidationSchema),
    defaultValues: data,
  })
  const { fields, append, remove } = useFieldArray({
    control,
    name: 'personal',
  })
  const { fields: professionalFields, append: professionalAppend, remove: professionalRemove } = useFieldArray({
    control,
    name: 'professional',
  })

  useEffect(() => {
    setActiveForm(() => ({ formId: id, getData: getValues, submit: handleSubmit }))
  }, [getValues, handleSubmit, id, setActiveForm])

  return (
    <FormContext.Provider value={{ control, handleSubmit, register, setValue, watch, formState }}>
      <Grid item xs={12} sm={12} md={12}>
        <Grid item xs={12} sm={12} md={12} textAlign="left">
          <h4>Referencias Personales</h4>
        </Grid>
        <Grid item xs={12} sm={12} md={12} textAlign="left">
          <Button
            variant="contained"
            color="success"
            type="submit"
            startIcon={<PlusIcon />}
            onClick={() => append({ name: '', phone: '' })}
          >
            Adicionar Referencia
          </Button>
        </Grid>
        {fields.map((field, index) => (
          <PersonalReferenceBlock index={index} remove={remove} key={field.id} />
        ))}
        <Grid item xs={12} sm={12} md={12}>
          <Typography variant="inherit" color="red" align="left" style={{ marginTop: 10 }}>
            {formState?.errors?.personal?.message?.toString()}
          </Typography>
        </Grid>
      </Grid>
      <Grid item xs={12} sm={12} md={12}>
        <Grid item xs={12} sm={12} md={12} textAlign="left">
          <h4>Referencias Profissionales</h4>
        </Grid>
        <Grid item xs={12} sm={12} md={12} textAlign="left">
          <Button
            variant="contained"
            color="success"
            type="submit"
            startIcon={<PlusIcon />}
            onClick={() => professionalAppend({ company: '', name: '', phone: '' })}
          >
            Adicionar Referencia
          </Button>
        </Grid>
        {professionalFields.map((field, index) => (
          <ProfessionalReferenceBlock index={index} remove={professionalRemove} key={field.id} />
        ))}
        <Grid item xs={12} sm={12} md={12}>
          <Typography variant="inherit" color="red" align="left" style={{ marginTop: 10 }}>
            {formState?.errors?.professional?.message?.toString()}
          </Typography>
        </Grid>
      </Grid>
    </FormContext.Provider>
  )
}
